import { render, staticRenderFns } from "./GameInfo.vue?vue&type=template&id=638f5f19&scoped=true"
import script from "./GameInfo.vue?vue&type=script&lang=js"
export * from "./GameInfo.vue?vue&type=script&lang=js"
import style0 from "./GameInfo.vue?vue&type=style&index=0&id=638f5f19&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638f5f19",
  null
  
)

export default component.exports